module.exports = __webpack_public_path__ + "media/Icons/camera-pos/cam_15-ca6de277791dfb7a703a587c6f794893.png";